import neo4j from 'neo4j-driver/lib/browser/neo4j-web'
var Config = {}

const query = (queryStr, callback) => {
  if (!Config.user || !Config.pass) return callback('neo4j user and pass require!')
  const driver = neo4j.driver(Config.host, neo4j.auth.basic(Config.user, Config.pass))
  const session = driver.session();
  const resultPromise = session.writeTransaction(tx => tx.run(queryStr))
  resultPromise.then(result => {
    session.close()
    const results = result.records.slice()
    driver.close()
    callback(null, results)
  }).catch(error => {
    callback(error, null)
  })
}

const convert = (data) => {
  var nodes = [], links = []
  for (let graph of data) {
    const n = graph._fields.filter(x => x.type === undefined)
    const l = graph._fields.filter(x => x.type)
    for (let startNode of n) {
      nodes.push({
        label: startNode.labels.join(),
        id: startNode.identity.low.toString(),
        properties: startNode.properties
      })
      const rels = l.filter(x => x.start.low === startNode.identity.low)
      for (let rel of rels) {
        const endNodes = n.filter(x => x.identity.low === rel.end.low)
        for (let endNode of endNodes) {
          links.push({
            source: startNode.identity.low.toString(),
            target: endNode.identity.low.toString(),
            title: rel.type
          })
        }
      }
      for (let key in startNode.properties) {
        const value = startNode.properties[key]
        const _id = startNode.identity.low + key.toLowerCase() + value.toLowerCase()
        nodes.push({
          label: key,
          id: _id,
          type: 'property',
          value,
          isHighlight: startNode.highlight && startNode.highlight.indexOf(key) > -1
        })
        links.push({
          source: startNode.identity.low.toString(),
          target: _id.toString(),
          title: 'property'
        })
      }
    }
  }
  return { nodes, links }
}

export default {
  setup: (_config) => Config = _config,
  query,
  convert
}


// WEBPACK FOOTER //
// ./src/lib/components/core.js